import {useNavigate} from "react-router-dom";
import {Box, Button, Stack, Typography} from "@mui/material";
import {EventSeat, Logout, Settings, Schedule, PeopleAlt} from "@mui/icons-material";
import {signOut} from "../api/AiAgentApi";
import React from "react";

export const Header = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
            }}
        >
            <Typography variant="h5">Админка: AI-Agent PEREPLЁT</Typography>

            <Stack direction="row" spacing={2}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => navigate("/ai-test-containers")}
                    sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1.2,
                        boxShadow: 1,
                        "&:hover": { boxShadow: 3 },
                    }}
                >
                    AI-TEST
                </Button>

                <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<PeopleAlt />}
                    onClick={() => navigate("/users")}
                    sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1.2,
                        boxShadow: 1,
                        "&:hover": { boxShadow: 3 },
                    }}
                >
                    Пользователи
                </Button>

                <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<EventSeat />}
                    onClick={() => navigate("/reservations")}
                    sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1.2,
                        boxShadow: 1,
                        "&:hover": { boxShadow: 3 },
                    }}
                >
                    Брони
                </Button>

                <Button
                    variant="outlined"
                    color="info"
                    startIcon={<Schedule />}
                    onClick={() => navigate("/deferred-actions")}
                    sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1.2,
                        boxShadow: 1,
                        "&:hover": { boxShadow: 3 },
                    }}
                >
                    Отложенные действия
                </Button>

                <Button
                    variant="outlined"
                    color="inherit"
                    startIcon={<Settings />}
                    onClick={() => navigate("/")}
                    sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1.2,
                        boxShadow: 1,
                        "&:hover": { boxShadow: 3 },
                    }}
                >
                    Настройки
                </Button>

                <Button
                    variant="contained"
                    color="error"
                    startIcon={<Logout />}
                    onClick={() => {
                        signOut();
                        window.location.reload();
                    }}
                    sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1.2,
                        boxShadow: 2,
                        "&:hover": { boxShadow: 4 },
                    }}
                >
                    Выйти
                </Button>
            </Stack>
        </Box>
    );
};
